import { render, staticRenderFns } from "./test-provider.vue?vue&type=template&id=a8b1934a&scoped=true&"
import script from "./test-provider.vue?vue&type=script&lang=js&"
export * from "./test-provider.vue?vue&type=script&lang=js&"
import style0 from "./test-provider.vue?vue&type=style&index=0&id=a8b1934a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b1934a",
  null
  
)

export default component.exports